import { render, staticRenderFns } from "./symbiotetwo.vue?vue&type=template&id=10abe349&scoped=true&"
import script from "./symbiotetwo.vue?vue&type=script&lang=js&"
export * from "./symbiotetwo.vue?vue&type=script&lang=js&"
import style0 from "./symbiotetwo.vue?vue&type=style&index=0&id=10abe349&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10abe349",
  null
  
)

export default component.exports